import React from 'react';
import { brandAsset, BRAND_NAME } from '../../../config/brand';

export default ({ className }: { className?: string }) => (
  <img src={brandAsset('logo.svg')} className={className} alt={BRAND_NAME} />
);
